<script>
  import { appSession, appConstants } from "../stores/app.js";

  // send an invitation to join to pilot with email
  export function PilotInvitation(email) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", $appConstants.apiURLBase + "actions/pilotinvitation");
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.setRequestHeader("Authorization", "Bearer " + $appSession.authorisationToken);
      xhr.send(JSON.stringify({ email: email }));
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve();
        } catch (error) {
          reject(error);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };      
    });
  }

  // request a password reset
  export function PasswordResetRequest(role, email) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", $appConstants.apiURLBase + "actions/passwordresetrequest");
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.send(JSON.stringify({ email, role }));
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve();
        } catch (error) {
          reject(error);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };      
    });
  }

  // password reset
  export function PasswordReset(request, password) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", $appConstants.apiURLBase + "actions/passwordreset");
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.send(JSON.stringify({ role: "pilot", request: request, password: password }));
      xhr.onload = () => {
        try {
          console.log(xhr.response);
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve();
        } catch (error) {
          reject(error);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };      
    });
  }

  // delete emptyleg
  export function EmptyLegDelete(emptyLegId) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", $appConstants.apiURLBase + "actions/emptylegdelete");
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.setRequestHeader("Authorization", "Bearer " + $appSession.authorisationToken);
      xhr.send(JSON.stringify({ emptylegid: emptyLegId }));
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve();
        } catch (error) {
          reject(error);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };
    });
  }

  // pilot setupemptyleg
//  export function PilotSetup(email, authorisationCode, password, city, state, country, postcode) {
  export function PilotSetup(authorisationCode, password, city, state, country, postcode) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", $appConstants.apiURLBase + "actions/pilotsetup");
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
//      xhr.send(JSON.stringify({ email: email, authorisationcode: authorisationCode, password: password, city: city, state: state, country: country, postcode: postcode }));
      xhr.send(JSON.stringify({ authorisationcode: authorisationCode, password: password, city: city, state: state, country: country, postcode: postcode }));
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve(response.token);
        } catch (error) {
          reject(error);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };
    });
  }
  
    // cancel jumpseat request
  export function JumpseatRequestCancel(jumpseatRequestId) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", $appConstants.apiURLBase + "actions/jumpseatrequestcancel");
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.setRequestHeader("Authorization", "Bearer " + $appSession.authorisationToken);
      xhr.send(JSON.stringify({ jumpseatrequestid: jumpseatRequestId }));
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve(response.token);
        } catch (error) {
          reject(error);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };
    });
  }
</script>
